module.exports = __webpack_public_path__ + "static/img/HKMA.2d6222a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HKMA.png
// module id = j02X
// module chunks = 11